import { Outlet, Route } from 'react-router-dom';

import { OAuthProvider } from '../components/oAuth/oAuth.context';

import { SettingsIntegrationsCardsCustomCreateView } from './views/create';
import { SettingsIntegrationsCardsCustomEditView } from './views/edit';
import { SettingsIntegrationsCardsCustomTestView } from './views/test';

const ContextLayout = () => (
  <OAuthProvider>
    <Outlet />
  </OAuthProvider>
);

export const settingsIntegrationsCardsCustomRoutes = (
  <Route element={<ContextLayout />}>
    <Route path="custom-card">
      <Route
        path="edit/:id"
        element={<SettingsIntegrationsCardsCustomEditView />}
      />
      <Route
        path="create"
        element={<SettingsIntegrationsCardsCustomCreateView />}
      />
      <Route
        path="test/:id"
        element={<SettingsIntegrationsCardsCustomTestView cardType="custom" />}
      />
    </Route>
  </Route>
);
